import HourlyPricesModal from "./HourlyPricesModal";

export default HourlyPricesModal;